import React, { useEffect, useState } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { Link, useNavigate } from "react-router-dom";
// import clientimg from "../asset/images/onboarding-pending/client-img.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import Loader from "../Components/Common/Loader";
// import { set } from "react-hook-form";
import {
  getName,
  goToClientDashboard,
  splitDate,
} from "../CommonMethhods/CommonMethods";
import { Client_Search } from "../Configuration/API_URL";
import { Constants } from "../CommonMethhods/Constants";

function OnboardingPendingSearch(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const searchVal = localStorage.getItem("clientSearch");
  let linecard = props.linecard;

  const [show, setShow] = useState(false);
  // const [searchDetail, setsearchDetail] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [value, setValue] = useState("");
  const [failedMsg, setFailedMsg] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let navigate = useNavigate();

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <>
      {props.loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        <div>
          {/* <Button variant="primary" onClick={handleShow}>
              filter
            </Button> */}
          <Tab.Content>
            <Tab.Pane eventKey="pending">
              <div className="oboarding-block-wrapper row card-box">
                {props.searchDetail ? (
                  Object.values(props.searchDetail).map((item, index) => {
                    return (
                      <div
                        className={`w-100 bottom-25 ${linecard}`}
                        key={index}
                      >
                        <a
                          onClick={() => {
                            goToClientDashboard(item.clientCode, item.pan);
                            localStorage.setItem("tabOnboarding","")
                            navigate("/client-dashboard");
                          }}
                          className="view-detail-btn"
                        >
                          <div className="card-box onboarding-card">
                            <div className="client-img-checkbox-wrapper">
                              <div className="client-img-wrapper">
                                <div className="profile-image">
                                  {getName(item.clientname)}
                                </div>
                                {/* <img src={getName(item.name)} alt="" /> */}
                              </div>
                              <div>
                                {/* <input
                                                className="styled-checkbox"
                                                id="checkbox-first"
                                                type="checkbox"
                                                value="value1"
                                            />
                                            <label htmlFor="checkbox-first"></label> */}
                              </div>
                            </div>
                            <div className="onboarding-card-content">
                              {/* <ul className="onboarding-content-link-list">
                                <li className="fingerprint-icon-wrapper">
                                  <span className="icon-fingerprint fingerprint-icon"></span>
                                </li>
                                <li className="user-icon-wrapper">
                                  <span className="icon-verified-user"></span>
                                </li>
                                
                                <li className="onboard-new-link">
                                  <Link to="#" className="">
                                    {Constants.New}
                                  </Link>
                                </li>
                              </ul> */}
                              {/* <div className="view-btn-wrapper">
                                            <a target='_blank' href="/Client-Dashboard" className="view-detail-btn">View Details</a>
                                        </div> */}
                              <div className="clientname-info">
                                <div className="clientname-time-wrapper">
                                  <p className="username">
                                    <span>{item.clientname}</span>
                                  </p>
                                  <div className="created-time-wrapper">
                                    <span className="icon-calendar onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>
                                        {splitDate(item.createddatetime)}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                                <div className="client-info-status">
                                  <ul className="call-web-wrapper">
                                    <li>
                                      <span className="icon-phone-icon onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>{item.mobile}</span>
                                      </span>
                                    </li>
                                    <li>
                                      <span className="icon-client-code onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>{item.clientCode}</span>
                                      </span>
                                    </li>
                                    {/* <li>
                                    <span className="icon-android onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      Android
                                    </span>
                                  </li> */}
                                  </ul>
                                  {/* <ul className="call-lead-stauts-wrapper"> */}
                                  {/* <li>
                                    <div>
                                      <span className="icon-phone-call onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        Call Status
                                      </span>
                                    </div>
                                    <div className="call-status">
                                      <Form.Select
                                        aria-label="Default select example"
                                        className="select"
                                      >
                                        <option>Unable to Connect</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </Form.Select>
                                    </div>
                                  </li> */}
                                  {/* <li>
                                    <div>
                                      <span className="icon-doc-file onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label onboard-pending-icon">
                                        Lead Status
                                      </span>
                                    </div>
                                    <div className="call-status">
                                      <Form.Select
                                        aria-label="Default select example"
                                        className="select"
                                      >
                                        <option>
                                          Bank Proof Missing/Invalid
                                        </option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </Form.Select>
                                    </div>
                                  </li> */}
                                  {/* <li>
                                    <div>
                                      <span className="icon-client-user onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label onboard-pending-icon">
                                        Change Assignee
                                      </span>
                                    </div>
                                    <div className="call-status">
                                      <Form.Select
                                        aria-label="Default select example"
                                        className="select"
                                      >
                                        <option>Robin Singh Chadda</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                      </Form.Select>
                                    </div>
                                  </li> */}
                                  {/* </ul> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className="card-box alert-table text-center">
                    <div className="alert-title mb-0">
                      <h3>{Constants.No_Data}</h3>
                    </div>
                  </div>
                )}
              </div>
            </Tab.Pane>
          </Tab.Content>
          <div className="">
            <Modal
              show={show}
              onHide={handleClose}
              className="onboarding-popup-wrapper"
            >
              <Modal.Header closeButton>
                <Modal.Title>{Constants.Filters}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <div className="row">
                    <div className="col-md-4 col-sm-6 col-12">
                      <Form.Group
                        className="form-group"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>{Constants.PAN}</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter PAN Number"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Form.Group
                        className="form-group"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>{Constants.Date_Range}</Form.Label>
                        <Form.Control
                          type="date"
                          className="date-btn"
                          placeholder="Date Range Picker"
                          onfocus="(this.type='date')"
                          max={DateReverse}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Form.Group
                        className="form-group"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>{Constants.Updated_Date_Range}</Form.Label>
                        <Form.Control
                          type="date"
                          className="date-btn"
                          placeholder="Date Range Picker"
                          disabled
                          max={DateReverse}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Form.Group
                        className="form-group"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>{Constants.OnBoarding_Date}</Form.Label>
                        <Form.Control
                          type="date"
                          className="date-btn"
                          placeholder="Date Range Picker"
                        />
                      </Form.Group>
                    </div>
                    {/* <div className="col-md-4 col-sm-6 col-12">
                      <Form.Group
                        className="form-group"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>Updated Date Range</Form.Label>
                        <Form.Control
                          type="date"
                          className="date-btn"
                          placeholder="Date Range Picker"
                          disabled
                        />
                      </Form.Group>
                    </div> */}
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.KYC_Status}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example"
                            className="select"
                          >
                            <option>{Constants.Unable_Connect}</option>
                            <option value="1">{Constants.Verified}</option>
                            <option value="2">{Constants.Not_Verified}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Comments}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example "
                            className="select"
                          >
                            <option>{Constants.Unable_Connect}</option>
                            <option value="1">{Constants.One}</option>
                            <option value="2">{Constants.Two}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Calling_Status}</Form.Label>

                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example"
                            className="select disabled"
                            disabled
                          >
                            <option>{Constants.Unable_Connect}</option>
                            <option value="1">{Constants.One}</option>
                            <option value="2">{Constants.Two}</option>
                            <option value="3">{Constants.Three}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Lead_Status}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example"
                            className="select disabled"
                            disabled
                          >
                            <option>{Constants.Unable_Connect}</option>
                            <option value="1">{Constants.One}</option>
                            <option value="2">{Constants.Two}</option>
                            <option value="3">{Constants.Three}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Assignee}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example"
                            className="select disabled"
                            disabled
                          >
                            <option>{Constants.Unable_Connect}</option>
                            <option value="1">{Constants.One}</option>
                            <option value="2">{Constants.Two}</option>
                            <option value="3">{Constants.Three}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Source}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example"
                            className="select"
                          >
                            <option>{Constants.Select_Source}</option>
                            <option value="1">{Constants.Ekyc}</option>
                            <option value="2">{Constants.Samadhan}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Device}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example"
                            className="select disabled"
                            disabled
                          >
                            <option>{Constants.Select_Device}</option>
                            <option value="1">{Constants.One}</option>
                            <option value="2">{Constants.Two}</option>
                            <option value="3">{Constants.Three}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <Form.Group
                        className="form-group"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>{Constants.Referral_ID}</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Referral"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Is_Referred}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example"
                            className="select"
                          >
                            <option>{Constants.Select_Is_Referred}</option>
                            <option value="true">{Constants.Yes}</option>
                            <option value="false">{Constants.No}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                      <div className="form-group">
                        <Form.Label>{Constants.Screen_Identifier}</Form.Label>
                        <div className="call-status">
                          <Form.Select
                            aria-label="Default select example disabled"
                            className="select"
                            disabled
                          >
                            <option>
                              {Constants.Select_Screen_Identifier}
                            </option>
                            <option value="1">{Constants.One}</option>
                            <option value="2">{Constants.Two}</option>
                            <option value="3">{Constants.Three}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <input
                  type="submit"
                  value="Submit"
                  className="filter filter-submit"
                />
                <input
                  type="reset"
                  value="Reset"
                  className="filter filter-reset"
                />
                <input
                  type="submit"
                  value="Save as Filter"
                  className="filter filter-save"
                  onClick={handleClose}
                />
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      )}
    </>
  );
}

export default OnboardingPendingSearch;
